"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractPrint = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_1 = __importDefault(require("moment"));
const snarkdown_1 = __importDefault(require("snarkdown"));
const contract_1 = require("../../../model/contract");
const helpers_1 = require("../../../utils/helpers");
const num2textfr_1 = require("../../../utils/num2textfr");
const form_for_1 = require("../../../widgets/form_for");
const contract_md_js_1 = __importDefault(require("./contract.md.js"));
exports.ContractPrint = {
    contract: {},
    loading: true,
    fetch(id) {
        this.loading = true;
        contract_1.ContractProvider.show(id).then((data) => {
            this.contract = data;
            this.loading = false;
        });
    },
    oncreate(node) {
        let id = node.attrs.contract_id;
        this.fetch(id);
    },
    link(id) {
        return `#/contracts/${id}/print`;
    },
    renderPrintToolbox() {
        return (0, mithril_1.default)("div", { class: "print-toolbox" }, (0, mithril_1.default)("button", {
            class: "button",
            onclick: () => { print(); }
        }, (0, helpers_1.iconSpan)("fa-print"), (0, mithril_1.default)("span", "Imprimer")));
    },
    renderTopCapsule() {
        return [
            (0, mithril_1.default)("img", { src: "/logo_contract.jpg" }),
            (0, form_for_1.columns)((0, mithril_1.default)("div", (0, mithril_1.default)("div", (0, mithril_1.default)("strong", "Centre SESAME")), (0, mithril_1.default)("div", "39, bd de Magenta, 75010 PARIS"), (0, mithril_1.default)("div", (0, mithril_1.default)("a", { href: "http://www.centresesame.com" }, "www.centresesame.com")), (0, mithril_1.default)("div", "01 40 35 41 86"), (0, mithril_1.default)("div", (0, mithril_1.default)("a", { href: "mailto:clientsesame@gmail.com" }, "clientsesame@gmail.com"))), (0, mithril_1.default)("div", (0, mithril_1.default)("div", (0, mithril_1.default)("strong", `CLIENT N° ${this.contract.client.id}`)), (0, mithril_1.default)("div", this.contract.client.name), (0, mithril_1.default)("div", `ANNEXE FORFAIT N°${this.contract.id}`), (0, mithril_1.default)("div", this.contract.offer.name))),
            (0, mithril_1.default)("hr")
        ];
    },
    view(_node) {
        if (this.loading) {
            return (0, mithril_1.default)(".content.container.print-container", this.renderPrintToolbox(), (0, mithril_1.default)("div", { style: "text-align: center;" }, "Chargement..."));
        }
        else {
            const vars = {
                "contract_id": this.contract.id,
                "total_hours": (0, helpers_1.minutesToString)(this.contract.initial_minutes),
                "total_hours_text": (0, num2textfr_1.minutesToText)(this.contract.initial_minutes),
                "total_hours_cancelable": (0, helpers_1.minutesToString)(this.contract.initial_cancelable_free_minutes),
                "total_hours_cancelable_text": (0, num2textfr_1.minutesToText)(this.contract.initial_cancelable_free_minutes),
                "created_at": (0, moment_1.default)(this.contract.created_at).format("LL"),
                "expires_at": (0, moment_1.default)(this.contract.expires_at).format("LL"),
                "validity_period": this.contract.validity_period,
                "validity_period_text": (0, num2textfr_1.numberToText)(this.contract.validity_period),
                "value": (0, helpers_1.moneyToString)(this.contract.value),
                "value_text": (0, num2textfr_1.moneyToText)(this.contract.value),
                "value_ttc": (0, helpers_1.moneyToString)((0, helpers_1.moneyAdd)(this.contract.value, this.contract.vat)),
                "value_ttc_text": (0, num2textfr_1.moneyToText)((0, helpers_1.moneyAdd)(this.contract.value, this.contract.vat)),
                "num_payments": this.contract.payments.length,
                "num_payments_text": (0, num2textfr_1.numberToText)(this.contract.payments.length),
                "list_payments": this.contract.payments.map((p) => {
                    return `<li>${(0, helpers_1.moneyToString)(p.value)} (${(0, num2textfr_1.moneyToText)(p.value)}) dû le ${(0, moment_1.default)(p.due_at).format("dddd DD MMMM YYYY")}</li>`;
                }).join("")
            };
            let contract_replaced = contract_md_js_1.default.replace(/\{\{[a-z_A-Z0-9]+\}\}/g, function (match) {
                let token = match.substr(2, match.length - 4);
                return vars[token];
            });
            let html = (0, snarkdown_1.default)(contract_replaced);
            return (0, mithril_1.default)(".content.container.print-container", this.renderPrintToolbox(), this.renderTopCapsule(), (0, mithril_1.default)("div.content", mithril_1.default.trust(html)), (0, mithril_1.default)("footer", (0, mithril_1.default)("div", `SESAME - SARL au capital de 100 000 euros - 790 197 156 R.C.S. Paris - Siret: 790 197 156 00017`), (0, mithril_1.default)("div", `T.V.A. Intracommunautaire: FR4179019715600017 - Siège social: 39, bd de Magenta, 75010 Paris`), (0, mithril_1.default)("div", `Crédit Du Nord: FR76 3007 6020 4933 6533 0020 011`)));
        }
    }
};
